import { useUser } from "@components/user-context";
import { type DataTypeProvider } from "@devexpress/dx-react-grid";
import { useProductAnalyticsContext } from "@features/product-analytics/hooks";
import { formatting } from "@north-beam/nb-common";

export const ASPClickThrough = ({
  row,
  column,
}: DataTypeProvider.ValueFormatterProps) => {
  const { user } = useUser();
  const { filters, tabState } = useProductAnalyticsContext();

  const aspClickThrough = user.pathFromRoot(
    `/orders?${encodeURIComponent(
      row.name,
    )}&discountValue=%7B%22value%22%3A0%2C%22comparisonOperator%22%3A%22greaterThan%22%7D&dateRange="${
      filters.dateRange === "last30Days" ? "lastMonth" : filters.dateRange
    }"`,
  );
  return (
    <div className="px-2 flex justify-end items-center w-full h-full">
      {tabState.tabView === "product" ? (
        <a rel="noreferrer" target="_blank" href={aspClickThrough}>
          {formatting.formatCurrency(row[column.name], {
            code: user.currencies.currentCurrency,
          })}
        </a>
      ) : (
        formatting.formatCurrency(row[column.name], {
          code: user.currencies.currentCurrency,
        })
      )}
    </div>
  );
};
